import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import AddLocation from "./AddLocation";
import EditLocation from "./EditLocation";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const listEndpoint = ApiEndpoints.location.list;
const deleteEndpoint = ApiEndpoints.location.delete;
const tableHeader = ["Date", "Name", "status"];
const tbody = ["createdAt", "name", "status"];

export default function Location() {
  const [catId, setCatId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.locations;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (location_id) => {
    const payload = { location_id };
    try {
      const response = await ApiRequest("POST", deleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: 'Career Management',
    user: 'Admin',
    innerpage: 'Career Management / Locations'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}> Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          setModalShow={setModalEditShow}
          setId={setCatId}
        // onDelete={handleDelete}
        />
      </div>
      <AddLocation show={modalShow} onHide={() => setModalShow(false)} />
      <EditLocation show={modaleditShow} catId={catId} onHide={() => setModalEditShow(false)} />
    </>
  );
}
